<template>
    <div class="wrapper h-full w-full relative'">
        <TheHeading
            v-if="headerVisible"
            class="sticky"
            style="top: 0"
            :title="title"
            @on-back="handleBack"
        />
        <iframe
            v-if="isShow"
            :src="$route.query.src"
            width="100%"
            :height="headerVisible ? '90%' : '100%'"
        >
            Sorry, your browser does not support HTML5. Please use other modern browsers such as
            Chrome, Edge, etc.
        </iframe>
        <van-empty
            v-else
            class="absolute w-full"
            image="error"
            description="404 Not Found or Invalid URL"
        />
    </div>
</template>

<script>
import Vue from 'vue';
import { Empty } from 'vant';
import { RegExps } from '@/lib/utils';

Vue.use(Empty);

export default {
    name: 'Protocol',
    mounted() {
        if (!this.headerVisible) this.setWebviewTitle(this.title);
    },
    computed: {
        headerVisible() {
            // 显式指定 navbar 的显示与隐藏（默认不显示）
            return Boolean(this.$route.query.showNavbar);
        },
        title() {
            return this.$route.query.name || '';
        },
        // 协议链接为空或有误，会显示空状态提示
        isShow() {
            const iframeSrc = this.$route.query.src;
            return iframeSrc && RegExps.urlReg.test(iframeSrc);
        },
    },
    methods: {
        setWebviewTitle(title = '') {
            try {
                window.TitleCallback(title);
            } catch (e) {
                console.error(e);
            }
        },
        handleBack() {
            if ('location' in this.$route.query) {
                const location = JSON.parse(this.$route.query.location);
                this.$router.push(location);
            } else {
                this.$router.go(-1);
            }
        },
    },
};
</script>

<style scoped>
.wrapper {
    overflow-y: hidden;
}

iframe {
    border: unset;
}

.van-empty {
    top: 30%;
    left: 50%;
    transform: translate(-50%, -40%);
}

@media screen and (min-width: 500px) {
    .van-empty {
        top: 45%;
    }
}
</style>
